var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H10L8.59 0.59C8.21 0.21 7.7 0 7.17 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM10 11.79V10H7C6.45 10 6 9.55 6 9C6 8.45 6.45 8 7 8H10V6.21C10 5.76 10.54 5.54 10.85 5.86L13.64 8.65C13.84 8.85 13.84 9.16 13.64 9.36L10.85 12.15C10.7795 12.2191 10.6901 12.2658 10.5931 12.2842C10.4962 12.3026 10.3959 12.2918 10.305 12.2533C10.2141 12.2148 10.1366 12.1503 10.0823 12.0678C10.0281 11.9854 9.99942 11.8887 10 11.79Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.f2c4ffa688f533e10b2f671fdcb92540.svg";
export { ForwardRef as ReactComponent };